module.exports = __webpack_public_path__ + "static/media/addChild.07f18e87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/addChild.svg
// module id = 2017
// module chunks = 0